import { cn } from "@/lib/utils";
import { formatMoney } from "@/lib/formatters";

interface MoneyDisplayProps {
  value: number | null | undefined;
  className?: string;
}

/**
 * Muestra un monto con formato colombiano y números monoespaciados (tabular-nums)
 * para que las columnas se alineen.
 */
export function MoneyDisplay({ value, className }: MoneyDisplayProps) {
  return <span className={cn("money", className)}>{formatMoney(value)}</span>;
}
